import { customAxios } from "../http-common";
class configurationServices {
  configurationPersonal() {
    return customAxios.get("/app/configuration/personal");
  }
}
export default new configurationServices();
